import { jsx as _jsx } from "react/jsx-runtime";
const React = require("react");
import { Route } from "react-router";
import { loadingAsyncState } from "widgets-for-react";
import { fetchCollectionItemById } from "../../backendApi/CollectionApi";
import { previousOrNull } from "../../utils/asyncState";
import { CollectionItemDetailsWidget } from "./CollectionItemDetails/CollectionItemDetailsWidget";
import { CollectionOverviewWidget } from "./CollectionOverview/CollectionOverviewWidget";
import { lookupBranchId } from "./CollectionState";
export const CollectionRoutes = (param)=>{
    let { state, setState, config, localization } = param;
    if (config == 'off') return [];
    const setCollectionState = (update, callback)=>setState((appS0)=>({
                ...appS0,
                collection: update(appS0.collection)
            }), callback);
    const preferredBranchId = lookupBranchId(localization.selectedLocationId);
    const { route } = config;
    return [
        /*#__PURE__*/ _jsx(Route, {
            path: route,
            exact: true,
            render: (param)=>{
                let { history } = param;
                const overview = state.collection.overview;
                return CollectionOverviewWidget({
                    ...overview,
                    config,
                    history,
                    preferredBranchId
                }).run((update)=>{
                    setCollectionState((collS0)=>({
                            ...collS0,
                            overview: update({
                                ...collS0.overview,
                                config,
                                history,
                                preferredBranchId
                            })
                        }));
                });
            }
        }, "collection/overview"),
        /*#__PURE__*/ _jsx(Route, {
            path: `${route}/:itemId+`,
            render: (router)=>{
                const details = state.collection.details;
                const itemId = router.match.params['itemId'] || details.itemId;
                const item = itemId == details.itemId ? details.item : loadingAsyncState(fetchCollectionItemById(itemId), previousOrNull(details.item));
                return CollectionItemDetailsWidget({
                    ...details,
                    itemId,
                    item,
                    route,
                    preferredBranchId
                }).run((update)=>setCollectionState((collS0)=>({
                            ...collS0,
                            details: update({
                                ...collS0.details,
                                itemId,
                                item,
                                route,
                                preferredBranchId
                            })
                        })));
            }
        }, "collection/details")
    ];
};
